/**
 * Type Curve Area colour palette — one definition, shared on purpose.
 *
 * Used by the preview map's fills, outlines and legend, and by the context
 * table's area chip. The chip is how a row is tied to its polygon, so both have
 * to resolve the same slot for the same area or the link is broken.
 *
 * These are the g10 values of the Carbon tokens the mock's `areaColors.scss`
 * names — support-error, -info, -success, -caution-undefined, -caution-major.
 * Literals rather than `var(--cds-*)` because Mapbox paint properties are
 * evaluated by the GL renderer, which never sees CSS variables. Gold
 * (support-warning) is deliberately absent: it means "selected" here.
 */
export const AREA_COLORS = [
  '#da1e28',
  '#0043ce',
  '#24a148',
  '#8a3ffc',
  '#ff832b',
];

/** support-warning — the active row's fill. */
export const ACTIVE_COLOR = '#f1c21b';

/**
 * The palette slot for an area, by its position in the area list.
 * @param {number} index - Position of the area, target first.
 * @return {string} Hex colour for that slot.
 */
export const colorForArea = (index: number) =>
  AREA_COLORS[index % AREA_COLORS.length];
